module.exports = __webpack_public_path__ + "img/niouhuang.prt.aee3729b.jpg";